const awsmobile = {
    Auth: {
        // REQUIRED - Amazon Cognito Region
        region: 'eu-north-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'eu-north-1_SgbcpXfWF',

        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: '3tah3afkqsi47tm5bu67jrgb86',

        // Required for Cognito's first-login user migration trigger.
        authenticationFlowType: 'USER_PASSWORD_AUTH',

        oauth: {
            domain: 'raviremmi-test-720309307349.auth.eu-north-1.amazoncognito.com',
            scope: ['openid', 'email', 'profile'],
            redirectSignIn: 'https://test.raviremmi.com/auth/callback',
            redirectSignOut: 'https://test.raviremmi.com/',
            responseType: 'code',
        },
    }
};

export default awsmobile;
